
<div class="modal-header">
  <h4 class="modal-title">Book Driver Now 🚚</h4>
  <button type="button" class="my-modal__close" aria-label="Close" (click)="close()">
    <i class="fa-solid fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="bookingForm">
    <div class="my-input">
      <label>Source Postal Code: </label>
      <br>
      <span>{{ sourcePostalCode }}</span>
    </div>
    <div class="my-input">
      <label for="desitionationPostalCode">Destination Postal Code</label>
      <input [value]="destinationPostalCode" (change)="destinationPostalCode = $event.target.value; getEstimatedDistance(); destinationPostalCode = $event.target.value" class="form-control" id="desitionationPostalCode" type="text" />
    </div>

    <div class="my-input">
      <label for="day">Day</label>
      <input type="date" id="day" class="form-control" [min]="minDate" formControlName="day" />
    </div>

    <div class="my-input">
      <label for="time" class="form-label">Time</label>
      <input type="time" id="time" class="form-control" formControlName="time" />
    </div>

    <div class="my-input">
      <label for="transportType" class="form-label">Transport Type: </label>
      <select id="transportType" class="form-control" formControlName="transportType">
        <!--please don't change this-->
         <option *ngFor="let val of possibleTransportTypes" [value]="val">
          {{val}}
         </option>
      </select>
    </div>
    <div class="my-input">
      <label for="itemSize" class="form-label">Item Size: </label>
      <select id="itemSize" class="form-control" formControlName="itemSize">
        <!--please don't change this-->
        <option *ngFor="let val of possibleItemSize" [value]="val">
          {{val}}
         </option>
      </select>
    </div>

    <div class="my-input">
      <label for="frequency" class="form-label">Frequency: </label>
      <select id="frequency" class="form-control" formControlName="frequency">
         <!--please don't change this-->
        <option *ngFor="let val of possibleFrequency" [value]="val">
          {{val}}
         </option>
      </select>
    </div>

    <div class="my-input">
      <label for="priceBid" class="form-label">Price Bid</label>
      <input type="number" id="priceBid" class="form-control" formControlName="priceBid" min="0" placeholder="Price Bid" />
    </div>
    <div class="my-input full-row">
      <label for="remark" class="form-label">Remark (optional)</label>
      <input type="text" id="remark" class="form-control" formControlName="remark" min="0" placeholder="Remark" />
    </div>
    <div class="my-checkbox full-row">
      <input type="checkbox" name="agree" id="agree" formControlName="agree" />
      <label for="agree">I agree to allow the driver to contact me directly</label>
    </div>
  </form>
</div>

<div class="modal-footer" style="display: flex; justify-content: end; width: 100%">
  <span style="justify-self: center">Estimated ditance: {{ estimatedDistance }}</span>
  <button type="button" class="my-button-3 error" (click)="close()">Close</button>
  <button type="button" class="my-button-3" (click)="submit()">Submit</button>
</div>
